<template>
	<div class="pagination-content">
        <div class="pagination-content__text mr-24">
			<div v-if="from && to">
				{{ $t("pagination.showing") }}
				<b class="heading-bold">{{ from }}-{{ to }}</b>
				{{ $t("pagination.of") }} {{ total }}
				{{ text }}
			</div>
        </div>
		<ul
			v-if="total > limit"
			class="pagination-content__paginator list-reset"
		>
			<li class="pagination-content__paginator__arrow">
				<button
					type="button"
					@click="fetchSelected(prevPage)"
					:class="prevDisabled"
					:disabled="prevDisabledDis"
					title="Prethodna strana"
					class="mr-3"
				>
                    <img src="/imgs/icons/arrow_left.svg" class="pagination-content__paginator__arrow__image" alt="">
				</button>
			</li>
			<div class="pagination-content__paginator__pages">
                <li v-for="page in pages" :key="page" class="pagination-content__paginator__page">
                    <button
                        type="button"
                        :class="{ active: page === currentPage, disabled: page === '...' }"
                        :disabled="page === '...'"
                        @click="fetchSelected(page)"
                        class="pagination-content__paginator__page__button"
                    >
                        {{ page }}
                    </button>
                </li>
            </div>
			<li class="pagination-content__paginator__arrow">
				<button
					type="button"
					:class="nextDisabled"
					@click="fetchSelected(nextPage)"
					:disabled="nextDisabledDis"
					title="Sljedeća strana"
					class="ml-3"
				>
                    <img src="/imgs/icons/arrow_left.svg"
                         class="pagination-content__paginator__arrow__image pagination-content__paginator__arrow__image--right"
                         alt=""
                    >
				</button>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: "Paginator",
	props: {
		limit: {
			type: Number,
			default: 10,
		},
		nextPagePrevent: {
			type: Boolean,
			default: false,
		},
		text: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			currentPage: 1,
			lastPage: "",
			total: 0,
			from: 1,
			to: 10
		};
	},
	computed: {
		pages() {
			let shownPages = 4;
			let result = [];

			if (this.lastPage - shownPages <= 1) {
				return this.lastPage;
			}

			if (this.currentPage > this.lastPage - shownPages) {
				result.push(
					1,
					"...",
					this.lastPage - 3,
					this.lastPage - 2,
					this.lastPage - 1,
					this.lastPage
				);
				return result;
			}

			result.push(
				this.currentPage,
				this.currentPage + 1,
				this.currentPage + 2,
				this.currentPage + 3,
				"...",
				this.lastPage
			);
			return result;
		},
		prevDisabled() {
			return this.currentPage === 1 ? "opacity-50 cursor-not-allowed disabled" : "";
		},
		nextDisabled() {
			return this.currentPage === this.lastPage
				? "opacity-50 cursor-not-allowed disabled"
				: "";
		},
		nextPage() {
			return this.currentPage + 1;
		},
		prevPage() {
			return this.currentPage - 1;
		},
		prevDisabledDis() {
			return this.currentPage === 1;
		},
		nextDisabledDis() {
			return this.currentPage === this.lastPage;
		},
	},
	methods: {
		makePagination(meta) {
			this.lastPage = meta.last_page;
			this.total = meta.total;
			this.from = meta.from;
			this.to = meta.to;
		},
		fetchSelected(page) {
			if (!this.nextPagePrevent) {
				this.currentPage = page;
			}
			this.$emit("fetch", page);
		},
	},
};
</script>

<style lang="scss">

.pagination-content {
    margin-top: -24px;
    padding: 32px 16px;

    @media (min-width: 767px) {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
    }

    &__text {
        font-weight: 500;
        color: #9e9e9f;
        margin-top: 24px;
    }

    &__paginator {
        display: flex;
        justify-content: center;
        margin-top: 24px;

        li {
            list-style-type: none !important;

            button:focus {
                outline: none !important;
            }
        }

        &__arrow {
            display: flex;

            button {
                display: flex;
                align-items: center;
            }

            &__image {
                width: 16px;

                &--right {
                    transform: rotate(180deg);
                }
            }
        }

        &__pages {
            display: flex;
            flex-wrap: wrap;
            margin-top: -16px;
        }

        &__page {
            margin-top: 16px;
            padding: 0 16px;

            &__button {
                color: #c1c0c4;
                font-size: 16px;
                font-weight: 500;
                font-family: Gilroy, sans-serif;

                &.active {
                    color: #646464;
                    font-weight: 700;
                }

                &:focus,
                &.active {
                    outline: none !important;
                }
            }
        }
    }
}
</style>

<style scoped>
.disabled,
.disabled:active,
.disabled:hover {
    cursor: not-allowed;
    color: #b0b0b0;
    z-index: -1;
}
</style>
